var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32216 7.25873C7.84286 6.76271 8.68708 6.76271 9.20778 7.25873L16.265 13.9814L23.3222 7.25873C23.8429 6.76271 24.6871 6.76271 25.2078 7.25873C25.7285 7.75475 25.7285 8.55895 25.2078 9.05497L18.1506 15.7776L25.2078 22.5003C25.7285 22.9963 25.7285 23.8005 25.2078 24.2966C24.6871 24.7926 23.8429 24.7926 23.3222 24.2966L16.265 17.5739L9.20778 24.2966C8.68708 24.7926 7.84286 24.7926 7.32216 24.2966C6.80147 23.8005 6.80147 22.9963 7.32216 22.5003L14.3794 15.7776L7.32216 9.05497C6.80147 8.55895 6.80147 7.75475 7.32216 7.25873Z",
    fill: "#3F3F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4221ed3fc7e4e9f98252153ea7b367ed.svg";
export { ForwardRef as ReactComponent };